import { useSelector } from 'react-redux';

import { Plan } from 'modules/subscription';
import { UserSelectors } from '../redux';

type PlanName = 'Free' | 'Pro' | 'Unlimited';
type PlanPeriod = 'monthly' | 'yearly';

type UserPlanInfo = {
  name: PlanName;
  period: PlanPeriod;
  subscriptionEndsAt: string | null;
  isFree: boolean;
};

const PLAN_NAME_BY_TYPE: Record<Plan, PlanName> = {
  [Plan.Free]: 'Free',
  [Plan.Pro]: 'Pro',
  [Plan.Unlimited]: 'Unlimited',
};

export const useGetUserPlanInfo = (): UserPlanInfo => {
  const userPlan = useSelector(UserSelectors.userPlan);
  const subscriptionEndsAt = useSelector(UserSelectors.subscriptionEndsAt);

  const [type, interval] = userPlan.split('_');

  const name = PLAN_NAME_BY_TYPE[type as Plan] ?? Plan.Free;
  const period: PlanPeriod = interval === 'yearly' ? 'yearly' : 'monthly';
  const isFree = name === 'Free';

  return { name, period, subscriptionEndsAt, isFree };
};
